export default "__VITE_ASSET__DdZhnf5V__"